import React, { useEffect } from 'react';

import { Dates } from 'context/DateProvider/DateProvider';
import { initialiseChart } from 'features/Status/components/StatusHistory/StatusHistoryChart/utils/initialiseChart';
import { StatusData } from 'features/Status/types/statusData';

type StatusesChartProps = {
  chartId: string;
  chartData: StatusData[];
  minDateTimeRange: string;
  maxDateTimeRange: string;
  lineColor: string;
  dateTimeRange?: Dates;
  setDateTimeRange?: React.Dispatch<React.SetStateAction<Dates>>;
};

const StatusHistoryChart = ({
  chartId,
  chartData,
  minDateTimeRange,
  maxDateTimeRange,
  lineColor,
  dateTimeRange,
  setDateTimeRange,
}: StatusesChartProps) => {
  useEffect(() => {
    const root = initialiseChart(
      chartId,
      minDateTimeRange,
      maxDateTimeRange,
      chartData,
      lineColor,
      dateTimeRange,
      setDateTimeRange
    );

    return () => {
      root.dispose();
    };
  }, [chartData, dateTimeRange]);

  return (
    <div data-testid="statusHistoryChart" id={chartId} style={{ width: '100%', height: '6em' }} />
  );
};

export default StatusHistoryChart;
